<template>
  <v-menu>
    <template v-slot:activator="{ props }">
      <v-btn
        elevation="0"
        v-bind="props"
        class="px-1 mr-1"
        style="height: fit-content; min-width: fit-content !important"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.03809 13L5.62409 8.414C5.99914 8.03906 6.50776 7.82843 7.03809 7.82843C7.56841 7.82843 8.07703 8.03906 8.45209 8.414L13.0381 13M11.0381 11L12.6241 9.414C12.9991 9.03906 13.5078 8.82843 14.0381 8.82843C14.5684 8.82843 15.077 9.03906 15.4521 9.414L17.0381 11M11.0381 5H11.0481M3.03809 17H15.0381C15.5685 17 16.0772 16.7893 16.4523 16.4142C16.8274 16.0391 17.0381 15.5304 17.0381 15V3C17.0381 2.46957 16.8274 1.96086 16.4523 1.58579C16.0772 1.21071 15.5685 1 15.0381 1H3.03809C2.50765 1 1.99895 1.21071 1.62387 1.58579C1.2488 1.96086 1.03809 2.46957 1.03809 3V15C1.03809 15.5304 1.2488 16.0391 1.62387 16.4142C1.99895 16.7893 2.50765 17 3.03809 17Z"
            stroke="#666666"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </v-btn>
    </template>
    <v-list class="mt-1 rounded-lg pa-1">
      <v-list-item
        v-for="(item, index) in itemsSelect"
        :key="index"
        :value="index"
        @click="handleItemClick(item)"
      >
        <v-list-item-title>
          <span v-html="item.svgIcon"></span>
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { publishPost } from "@/store/publishPost/publishPost";
export default {
  props: ["fileSelected", "driveSelect", "editImage"],

  data() {
    return {
      itemsSelect: [
        {
          id: 0,
          title: "Upload from desktop",
          svgIcon:
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.75 12.5V16C17.75 16.4641 17.5656 16.9092 17.2374 17.2374C16.9092 17.5656 16.4641 17.75 16 17.75H3.75C3.28587 17.75 2.84075 17.5656 2.51256 17.2374C2.18437 16.9092 2 16.4641 2 16V12.5M14.25 6.375L9.875 2M9.875 2L5.5 6.375M9.875 2V12.5" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        },
        // {
        //   id: 1,
        //   title: "Add from my drive",
        //   svgIcon:
        //     '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1083_22243)"><path d="M7.16667 6.33333C6.52333 6.33333 6 5.81 6 5.16667C6 4.52333 6.52333 4 7.16667 4C7.81 4 8.33333 4.52333 8.33333 5.16667C8.33333 5.81 7.81 6.33333 7.16667 6.33333ZM7.16667 5C7.07467 5 7 5.07467 7 5.16667C7 5.35 7.33333 5.35 7.33333 5.16667C7.33333 5.07467 7.25867 5 7.16667 5Z" fill="#999999"/><path d="M13.4998 10.0004C13.3305 10.0004 13.1645 9.91377 13.0705 9.75777L11.4705 7.09111L10.0778 9.11711C9.99648 9.23511 9.86848 9.31311 9.72582 9.33044C9.58382 9.34711 9.44048 9.30311 9.33382 9.20777L8.22048 8.21711L6.88382 9.82044C6.70648 10.0324 6.39182 10.0611 6.17982 9.88444C5.96782 9.70777 5.93915 9.39244 6.11582 9.18044L7.78248 7.18044C7.86915 7.07644 7.99448 7.01177 8.12915 7.00177C8.26648 6.98977 8.39715 7.03644 8.49848 7.12644L9.57515 8.08377L11.0878 5.88377C11.1838 5.74311 11.3365 5.65511 11.5158 5.66711C11.6858 5.67244 11.8412 5.76377 11.9292 5.90977L13.9291 9.24311C14.0711 9.47977 13.9945 9.78711 13.7578 9.92911C13.6765 9.97777 13.5878 10.0004 13.4998 10.0004Z" fill="#999999"/><path d="M16.1667 17.9997H3.83333C2.822 17.9997 2 17.1777 2 16.1663V12.4997C2 11.8563 2.52333 11.333 3.16667 11.333H5.004C5.52333 11.333 5.972 11.667 6.12133 12.165L6.83667 14.5477C6.858 14.6183 6.922 14.6663 6.996 14.6663H13.004C13.078 14.6663 13.142 14.6183 13.1633 14.5477L13.8787 12.1643C14.028 11.667 14.4767 11.333 14.996 11.333H16.8333C17.4767 11.333 18 11.8563 18 12.4997V16.1663C18 17.1777 17.178 17.9997 16.1667 17.9997ZM3.16667 12.333C3.07467 12.333 3 12.4077 3 12.4997V16.1663C3 16.6257 3.374 16.9997 3.83333 16.9997H16.1667C16.626 16.9997 17 16.6257 17 16.1663V12.4997C17 12.4077 16.9253 12.333 16.8333 12.333H14.996C14.922 12.333 14.858 12.381 14.8367 12.4517L14.1213 14.835C13.972 15.3323 13.5233 15.6663 13.004 15.6663H6.996C6.47667 15.6663 6.028 15.3323 5.87867 14.8343L5.16333 12.4517C5.142 12.381 5.078 12.333 5.004 12.333H3.16667Z" fill="#999999"/><path d="M4.5 10.3333C4.224 10.3333 4 10.1093 4 9.83333V3.83333C4 2.822 4.822 2 5.83333 2H14.1667C15.178 2 16 2.822 16 3.83333V9.83333C16 10.1093 15.776 10.3333 15.5 10.3333C15.224 10.3333 15 10.1093 15 9.83333V3.83333C15 3.374 14.626 3 14.1667 3H5.83333C5.374 3 5 3.374 5 3.83333V9.83333C5 10.1093 4.776 10.3333 4.5 10.3333Z" fill="#999999"/></g><defs><clipPath id="clip0_1083_22243"><rect width="16" height="16" fill="white" transform="translate(2 2)"/><clipPath></defs></svg>',
        // },
        // {
        //   id: 2,
        //   title: "Edit image",
        //   svgIcon:
        //     '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1083_22254)"><path d="M4.5 1.5C2.84315 1.5 1.5 2.84315 1.5 4.5V8.5C1.5 8.77615 1.27614 8.375 1 8.375C0.723857 8.375 0.5 9.15115 0.5 8.875V4.5C0.5 2.29086 2.29086 0.5 4.5 0.5H8C8.27615 0.5 8.5 0.723858 8.5 1C8.5 1.27614 8.27615 1.5 8 1.5H4.5Z" fill="#999999"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 8C0.723857 8 0.5 8.22385 0.5 8.5V11.5C0.5 13.7092 2.29086 15.5 4.5 15.5H11.5C13.7092 15.5 15.5 13.7092 15.5 11.5V8C15.5 7.72385 15.2761 7.5 15 7.5C14.7239 7.5 14.5 7.72385 14.5 8V11.1354C13.3542 9.34378 10.722 9.3661 9.57917 11.0922L8.28708 9.56522C6.75518 7.75477 3.90417 7.95993 2.64725 9.97103L1.51338 11.7852C1.50453 11.6913 1.5 11.5962 1.5 11.5V8.5C1.5 8.22385 1.27614 8 1 8ZM12.3575 14.3757L10.2672 11.9053C10.9535 10.4455 13.0607 10.4072 13.7804 11.8943L14.2115 12.7852C13.85 13.5466 13.1772 14.1316 12.3575 14.3757ZM11.1527 14.5L7.5237 10.2112C6.42948 8.918 4.39305 9.06453 3.49522 10.501L1.924 13.015C1.92162 13.0188 1.9192 13.0226 1.91673 13.0263C2.43909 13.9085 3.40048 14.5 4.5 14.5H11.1527Z" fill="#999999"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5097 1.01305C13.1938 0.328982 14.3029 0.328982 14.9869 1.01305C15.671 1.69712 15.671 2.80622 14.9869 3.4903L11.6237 6.85355C11.5299 6.94732 11.4028 7 11.2701 7H9.5C9.22385 7 9 6.77615 9 6.5V4.72988C9 4.59725 9.05268 4.47007 9.14645 4.3763L12.5097 1.01305ZM14.2799 1.72016C13.9863 1.42661 13.5103 1.42661 13.2168 1.72016L10 4.93698V6H11.063L14.2799 2.7832C14.5734 2.48964 14.5734 2.01371 14.2799 1.72016Z" fill="#999999"/></g><defs><clipPath id="clip0_1083_22254"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>',
        // },
      ],
      store: publishPost(),
    };
  },
  methods: {
    createFileInput() {
      if (this.fileInput) {
        document.body.removeChild(this.fileInput);
      }
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/* , video/*";  // Accept both images and videos

      input.multiple = true;     // Allow multiple files
      input.style.display = "none";
      document.body.appendChild(input);
      this.fileInput = input;
      return input;
    },

    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.store.facebookfilereel = files;
      const maxSize = 50 * 1024 * 1024;
      const validFiles = [];
      const errors = [];
      files.forEach((file) => {
        if (
          !file.type.startsWith("image/") &&
          !file.type.startsWith("video/")
        ) {
          errors.push(`${file.name} is not a supported file type.`);
          return;
        }
        if (file.size > maxSize) {
          errors.push(`${file.name} exceeds the maximum size of 50MB.`);
          return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          validFiles.push({ file, preview: e.target.result, type: file.type });
          // Emit event only after all files are processed
          if (validFiles.length + errors.length === files.length) {
            this.$emit("fileSelected", validFiles);
          }
        };
        reader.onerror = () => {
          errors.push(`Error reading file: ${file.name}`);
          if (validFiles.length + errors.length === files.length) {
            this.$emit("fileSelected", validFiles);
          }
        };
        reader.readAsDataURL(file);
      });
    },

    handleDriveSelect() {
      this.$emit("driveSelect");
    },

    handleEditImage() {
      this.$emit("editImage");
    },

    handleItemClick(item) {
      switch (item.id) {
        case 0: {
          // Upload from desktop
          const input = this.createFileInput();
          input.addEventListener("change", this.handleFileSelect, {
            once: true,
          });
          input.click();
          break;
        }
        case 1: {
          // Add from my drive
          this.handleDriveSelect();
          break;
        }
        case 2: {
          // Edit image
          this.handleEditImage();
          break;
        }
      }
    },
  },

  beforeUnmount() {
    // Clean up file input when component is destroyed
    if (this.fileInput && document.body.contains(this.fileInput)) {
      document.body.removeChild(this.fileInput);
    }
  },
};
</script>
